/**
 * Returns the used line-height of `element` in CSS pixels from layout-accurate
 * computed styles. Supports px, rem, em, %, and unitless values once resolved
 * by the browser. Falls back to a probe measurement for `line-height: normal`.
 */
export function getComputedLineHeightPx(element: HTMLElement): number {
  const computed = window.getComputedStyle(element);
  const parsedLineHeight = parseFloat(computed.lineHeight);

  if (Number.isFinite(parsedLineHeight) && parsedLineHeight > 0) {
    return parsedLineHeight;
  }

  if (computed.lineHeight !== "normal") {
    return 0;
  }

  return measureNormalLineHeightPx(element, computed);
}

function measureNormalLineHeightPx(
  element: HTMLElement,
  computed: CSSStyleDeclaration
): number {
  const parent = element.parentElement;
  if (!parent) return 0;

  const probe = document.createElement("span");
  probe.textContent = "\u200b";
  probe.style.font = computed.font;
  probe.style.lineHeight = "normal";
  probe.style.visibility = "hidden";
  probe.style.position = "absolute";
  probe.style.pointerEvents = "none";

  parent.appendChild(probe);
  const height = probe.offsetHeight || probe.getBoundingClientRect().height;
  parent.removeChild(probe);

  return height > 0 ? height : 0;
}
